import * as  ComponentGA from './GoogleAnalytics'

export const GoogleAnalytics = ComponentGA;